
import ContactForm from './components/ContactForm';
import contactus from "assets/img/profile/contactUs.jpg";

const Dashboard = () => {
  return (
 <section className="relative z-10 overflow-hidden bg-white py-10  mt-10 dark:bg-dark lg:py-[80px] rounded-lg bg-white shadow-lg"> 
 <div className="container">
  <div className="item">
      <div className=" overflow-hidden md:flex mr-5">
        {/* Image Section */}
        <div className="md:w-1/2 ml-5">
         <img
                className="h-full w-full object-cover rounded-lg"
                src={contactus}  
                alt="Office meeting"
              />
        </div>

        {/* Form Section */}
        <div className="md:w-1/2 p-8">
          <h2 className="text-2xl font-extrabold text-blue-900 mb-6">GET IN TOUCH WITH US</h2>
          <ContactForm />
        </div>
      </div>
    </div>
    </div>
 </section>
  );
};

export default Dashboard;
